import React from 'react';
import PropTypes from 'prop-types';
import { STATIC_PUBLIC_PATH, getAssetsDomain } from 'app-config/webpack/paths';

const AssetsFileResolver = ({ path, pathset, pathsetSizes, children, ...props }) => {
  if (
    (path && path.startsWith(STATIC_PUBLIC_PATH)) ||
    (pathset.length > 0 &&
      pathset.filter((setpath) => setpath.startsWith(STATIC_PUBLIC_PATH)).length !== 0)
  ) {
    throw new Error('Do not pass the static public path on the "path" or "pathset" property');
  }
  let resolvedPath = path;
  if (path && path.substring(0, 4) !== 'http') {
    resolvedPath = `${getAssetsDomain()}${STATIC_PUBLIC_PATH}${path}`;
  }
  const resolvedPathSet = pathset.map(
    (setpath, index) => `${getAssetsDomain()}${STATIC_PUBLIC_PATH}${setpath} ${pathsetSizes[index]}`,
  );

  return children({ ...props, resolvedPath, resolvedPathSet });
};
AssetsFileResolver.defaultProps = {
  pathset: [],
  pathsetSizes: [],
  children: ({ resolvedPath, resolvedPathSet, ...props }) => (
    <img src={resolvedPath} srcSet={resolvedPathSet.join(', ')} {...props} />
  ),
};
AssetsFileResolver.propTypes = {
  path: PropTypes.string,
  pathset: PropTypes.arrayOf(PropTypes.string),
  pathsetSizes: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.func,
};

export { AssetsFileResolver };
